import React from 'react'
import "./style.css"

const Loader = () => {
  return (
      <div id="loader"></div>
  )
}

export default Loader
